import React from 'react'
import { useTranslation } from 'react-i18next'
import { BaseSensitiveMessageSummary } from '../../commonComponents/CommonComponents'

export function SensitiveMessageSummary({ messageDetails, queueCachesState, queueCachesActions }) {
  const { t } = useTranslation()

  return (
    <BaseSensitiveMessageSummary
      messageDetails={messageDetails}
      queueCachesState={queueCachesState}
      queueCachesActions={queueCachesActions}
      labelsBlockProps={{
        heading: t('labels.labels', 'Labels'),
        columns: 10,
      }}
    />
  )
}
